import React, { memo } from 'react';

const ReturnsIframeRenderer = memo(({ iframeHeight, isUserDashboard, iframeRef }) => {
  // Always use relative paths to ensure the request goes through the proxy.
  // This allows the server/vite proxy to catch 'refused to connect' errors 
  // and display our friendly 'Syncing Records' message.
  const src = isUserDashboard ? "/returns/my-returns" : "/returns/seller-dashboard";
  
  const title = isUserDashboard ? "My Returns" : "Returns Management";
  const iframeKey = isUserDashboard ? "returns-iframe" : "seller-returns-iframe";
  const wrapperKey = isUserDashboard ? "user-returns-iframe-wrapper" : "seller-returns-iframe-wrapper";

  return (
    <div key={wrapperKey} className="w-full overflow-hidden" style={{ height: iframeHeight }}>
      <iframe
        ref={iframeRef}
        key={iframeKey}
        src={src}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title={title}
      ></iframe>
    </div>
  );
});

export default ReturnsIframeRenderer;